module.exports = __webpack_public_path__ + "img/0S6A0022.6cb7da5e.jpg";